// Chart.js Line Chart Implementation
document.addEventListener('DOMContentLoaded', function() {
    // Find all elements with data-chart="line"
    const lineChartElements = document.querySelectorAll('[data-chart="line"]');

    lineChartElements.forEach(function(element) {
        // Get the JSON data from the data-json attribute
        const jsonData = element.getAttribute('data-json');

        if (!jsonData) {
            console.warn('No data-json attribute found for line chart element');
            return;
        }

        try {
            // Parse the JSON data
            const chartData = JSON.parse(jsonData);

            // Prepare data for Chart.js
            const labels = chartData.map(item => item.year);

            // Dynamically detect the data field (score, ranking, etc.)
            const dataField = Object.keys(chartData[0]).find(key => key !== 'year');
            const values = chartData.map(item => item[dataField]);

            // Get chart type from data attribute
            const chartType = element.getAttribute('data-chart-type') || 'school';
            
            // Determine appropriate Y-axis range based on data field and chart type
            const getYAxisConfig = () => {
                if (dataField === 'ranking') {
                    // Ranking charts (both state and school use same range)
                    return { min: 0, max: 250 };
                } else if (dataField === 'score') {
                    if (chartType === 'state') {
                        // State average range
                        return { min: 45, max: 86 };
                    } else {
                        // Individual school range
                        return { min: 35, max: 85 };
                    }
                }
                // Default range for other types
                return { min: undefined, max: undefined };
            };

            const yAxisConfig = getYAxisConfig();

            // Create the chart
            const ctx = element.getContext('2d');
            new Chart(ctx, {
                type: 'line',
                data: {
                    labels: labels,
                    datasets: [{
                        label: dataField,
                        data: values,
                        borderColor: '#e01f29',
                        backgroundColor: 'rgba(224, 31, 41, 0.2)',
                        borderWidth: 2,
                        fill: false,
                        tension: 0.1
                    }]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: {
                            display: false
                        }
                    },
                    scales: {
                        y: {
                            beginAtZero: false,
                            min: yAxisConfig.min,
                            max: yAxisConfig.max,
                            grid: {
                                color: 'rgba(0, 0, 0, 0.1)'
                            }
                        },
                        x: {
                            grid: {
                                color: 'rgba(0, 0, 0, 0.1)'
                            }
                        }
                    }
                }
            });

        } catch (error) {
            console.error('Error parsing JSON data for line chart:', error);
        }
    });
});
